var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootprintShower(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 146.2V45.4004C32 28.8318 45.4315 15.4004 62 15.4004V15.4004C78.5685 15.4004 92 28.8318 92 45.4004V50.8004",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 77.2004C116 62.9514 104.449 51.4004 90.2004 51.4004C75.9514 51.4004 64.4004 62.9514 64.4004 77.2004",
    stroke: "white",
    strokeWidth: 6.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78.4004H123.2",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4166 93.4004V100.6M70.4004 93.4004V100.6M113.6 93.4004V100.6",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4166 113.8V121M70.4004 113.8V121M113.6 113.8V121",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintShower);
export default __webpack_public_path__ + "static/media/footprint_shower.d4bd0098593895cff5d53d50d0617685.svg";
export { ForwardRef as ReactComponent };